import * as z from "zod";
import {
  acumaticaIntegrationSchema,
  acumaticaReturnsSettingsSchema,
  MIN_FIRST_RETURN_NUMBER,
} from "./acumatica-integration-schema";

export const updateAcumaticaReturnsSettings = {
  name: "updateAcumaticaReturnsSettings" as const,
  input: acumaticaReturnsSettingsSchema.extend({
    /**
     * Seeds the team's return-number counter when it has none; the number
     * Acumatica sees on the first RMA. Ignored once the counter exists.
     */
    firstReturnNumber: z.number().int().min(MIN_FIRST_RETURN_NUMBER).optional(),
  }),
  output: acumaticaIntegrationSchema,
};
